import { h, render, Component } from 'preact';

export default class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue || '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.defaultValue !== nextProps.defaultValue) {
      this.setState({ value: nextProps.defaultValue });
    }
  }

  render() {
    const {formfield} = this.props;
    const {name} = formfield;
    let type = this.props.inputType === 'TEXTBOX' ?
      'text' :
      this.props.inputType.toLowerCase();

    let pattern = type === 'tel' ? '[0-9]*' : null;

    if (name === 'password') {
      type='password';
      pattern = '\\S{6,}';
    }

    if (name === 'postalCode') {
      type='text';
      pattern = '\\d{5,}';
    }


    return (
      <div id={this.props.fieldId}
           className={`inputfieldBlock ${name}`}>
        <label>{formfield.description}{this.props.required ? '*' : ''}</label>
        <input
          id={`formfield_${name}`}
          className={`inputfield ${name}`}
          required={this.props.required}
          type={type}
          value={this.state.value}
          pattern={pattern}
          onChange={e => this.onChange(name, e)}
        />
      </div>
    );
  }

  onChange(name, e) {
    if (e && e.target) {
      this.setState({ value: e.target.value });
      this.props.handleFieldChange(name, e.target.value);
    }
  }
}
